import DesCatalogPdfViewerViewModel from 'viewmodel/DesCatalogPartPdfViewerViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCatalogPartPdfViewer extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogPdfViewerViewModel);
    }

    get pdfSrc() {
        return this.getAttribute('pdfSrc');
    }

    getProps() {
        return {
            pdfSrc: this.pdfSrc,
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            locale: this.locale
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'pdfSrc'];
    }
}

if (!window.customElements.get('des-catalog-part-pdf-viewer')) {
    window.customElements.define('des-catalog-part-pdf-viewer', DesCatalogPartPdfViewer);
}
